var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("FormSubmitPopup", {
        attrs: {
          title: _vm.$t("splitOrder"),
          value: _vm.show,
          rightMethod: _vm.splitOrder,
          rightButtonText: _vm.$t("submit"),
          leftMethod: function() {
            return (_vm.show = false)
          },
          rightButtonLoading: _vm.loading,
          hasAlert: "",
          medium: ""
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function() {
              return [
                _c("Alert", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errorMessage,
                      expression: "errorMessage"
                    }
                  ],
                  attrs: { text: _vm.errorMessage }
                }),
                _vm._v(" "),
                _vm.skuItems.length
                  ? _vm._l(_vm.skuItems, function(item, index) {
                      return _c(
                        "v-layout",
                        { key: index, attrs: { "justify-space-between": "" } },
                        [
                          _c("v-flex", { attrs: { md3: "" } }, [
                            _vm._v("sku: " + _vm._s(item.sku))
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { md3: "" } }, [
                            _vm._v(
                              _vm._s(_vm.$t("total")) +
                                ": " +
                                _vm._s(
                                  item.quantityPurchased - item.quantityShipped
                                )
                            )
                          ]),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { md6: "" } })
                        ],
                        1
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.order
                  ? _c(
                      "v-layout",
                      { staticStyle: { "margin-top": "10px" } },
                      [
                        _c(
                          "v-flex",
                          [
                            _c("v-data-table", {
                              staticClass: "elevation-2 myDense",
                              attrs: {
                                headers: _vm.headers,
                                items: _vm.orders,
                                "item-key": "id",
                                "hide-actions": ""
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "items",
                                    fn: function(props) {
                                      return [
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _c(
                                              "v-layout",
                                              {
                                                attrs: { "justify-center": "" }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(_vm.$t("order")) +
                                                    " " +
                                                    _vm._s(props.index + 1) +
                                                    "\n                "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          _vm._l(props.item.items, function(
                                            row,
                                            j
                                          ) {
                                            return _c(
                                              "v-layout",
                                              {
                                                key: j,
                                                attrs: { "align-center": "" }
                                              },
                                              [
                                                _c("v-flex", [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(row.sku) +
                                                      "\n                  "
                                                  )
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "v-flex",
                                                  [
                                                    _c("v-text-field", {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "quantity"
                                                        ),
                                                        rules: [
                                                          _vm.fieldIsRequired(
                                                            "quantity"
                                                          ),
                                                          _vm.fieldIsInteger(
                                                            "quantity"
                                                          )
                                                        ]
                                                      },
                                                      model: {
                                                        value: row.qty,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            row,
                                                            "qty",
                                                            _vm._n($$v)
                                                          )
                                                        },
                                                        expression: "row.qty"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          }),
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _c(
                                              "v-layout",
                                              {
                                                attrs: { "justify-center": "" }
                                              },
                                              [
                                                _vm.order._key !== props.item.id
                                                  ? _c(
                                                      "v-btn",
                                                      {
                                                        attrs: {
                                                          icon: "",
                                                          flat: "",
                                                          dark: "",
                                                          color: "primary"
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                            return _vm.deleteOrder(
                                                              props.item,
                                                              props.index
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("v-icon", [
                                                          _vm._v("delete")
                                                        ])
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "headers",
                                    fn: function(props) {
                                      return [
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [_vm._v(_vm._s(_vm.$t("index")))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [_vm._v("skus")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticClass: "text-xs-center" },
                                          [
                                            _c(
                                              "v-layout",
                                              {
                                                attrs: { "justify-center": "" }
                                              },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      icon: "",
                                                      flat: "",
                                                      dark: "",
                                                      color: "primary"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.addOrder(
                                                          props.item
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v("add")
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2482451541
                              )
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62d7e6b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62d7e6b8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SplitOrderPopup.vue
// module id = null
// module chunks = 